import React from "react";
import { useTranslation } from "react-i18next";

//Style
import "./JobOfferAdviceSection.css";

const JobOfferAdviceSection = () => {
  const { t } = useTranslation();

  return (
    <section className="job-offer-advice-section">
      <div className="job-offer-advice-subcontainer">
        <h1 className="joa-title">{t("job_offer_page.advice_title")}</h1>
        <p className="joa-txt">{t("job_offer_page.advice_content")}</p>
      </div>
    </section>
  );
};

export default JobOfferAdviceSection;
